// extracted by mini-css-extract-plugin
module.exports = {"embedRoot":"EmbedNUrlVideoPlayer_embedRoot__19acC","root":"EmbedNUrlVideoPlayer_root__3EUDq"};